import {Box, useTheme} from '@mui/material';
import {blockExplorers} from '../../constants/block-explorers';
import {AddressButton} from './AddressButton';

export interface AddressViewProps {
  chainId: number;
  address: string;
}

export const ViewAddressButton = ({chainId, address}: AddressViewProps) => {
  const theme = useTheme();

  return (
    <AddressButton
      target="_blank"
      startIcon={
        <Box
          component="img"
          src={'/app/icons/eth-scan.png'}
          height="1.25rem"
          width="1.25rem"
        />
      }
      sx={{
        bgcolor: theme.palette.background.default,
        '&:hover': {bgcolor: theme.palette.background.default},
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: 1.2,
        px: 1.5,
        py: 1,
      }}
      href={`${blockExplorers[chainId]}address/${address}`}
      address={address}
    />
  );
};
